import { axios } from "@/utils/request";

const user_api = {
  login: "/api/wechat/users/login/",
  user: "/api/wechat/users/",
  collect: "/api/wechat/users/collect/",
  borrow: "/api/wechat/users/borrow/history",
  renew: "/api/wechat/users/renew/",
  userinfo: "/api/wechat/userinfo/",
  violation:"/api/wechat/violation/"
};

// export default api

export function login(parameter) {
  return axios({
    url: user_api.login,
    method: "post",
    data: parameter,
  });
}

export function borrowhistory(parameter) {
  return axios({
    url: user_api.borrow,
    method: "get",
    params: parameter,
  });
}

export function userCollection() {
  return axios({
    url: user_api.collect,
    method: "get",
  });
}

export function bookRenew(borrowId) {
  return axios({
    url: user_api.renew + borrowId,
    method: "post",
  });
}

export function getUserInfo() {
  return axios({
    url: user_api.userinfo,
    method: "get",
  });
}

export function editUserInfo(parameter) {
  return axios({
    url: user_api.userinfo,
    method: "put",
    data:parameter
  });
}

export function updateIdcard(idcard) {
  return axios({
    url: user_api.userinfo + "/idcard/" + idcard,
    method: "put",
  });
}

export function getIdcard() {
  return axios({
    url: user_api.userinfo + "/idcard/",
    method: "get",
  });
}

export function updateSerialId(serialId) {
  return axios({
    url: user_api.userinfo + "/serialId/" + serialId,
    method: "put",
  });
}

export function getSerialId() {
  return axios({
    url: user_api.userinfo + "/serialId/",
    method: "get",
  });
}

export function getViolation(parameter) {
  return axios({
    url: user_api.violation,
    method: "get",
    params: parameter,
  });
}